module.exports = __webpack_public_path__ + "static/media/img-wallpaper-manager@2x.7503338f.png";